import { getAuthorizationHeader } from "./auth_service";
import axios from "axios";
const qs = require("qs");

export const createTeam = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/teams`,
    { data: {...body, accounts: [localStorage.getItem("accountId")]} },
    getAuthorizationHeader()
  );

  let teamList = JSON.parse(localStorage.getItem("teamIDs"));
  let teamsIds = teamList?.length ? teamList : [];
  teamList = Array.isArray(teamsIds) ? teamsIds : [teamsIds];

  teamsIds.push({id: res.data.data.id, label: res.data.data.attributes.name});
  
  localStorage.setItem("teamIDs", JSON.stringify(teamsIds));

  return res.data.data;
};

export const deleteTeam = async (id) => {
  let res = await axios.delete(
    process.env.REACT_APP_BACKEND_URL + `api/teams/${id}`,
    getAuthorizationHeader()
  );
  return res;
};

export const getTeams = async () => {
  const query = qs.stringify({
    filters: {
      accounts: {
        id : {
          $in: [localStorage.getItem("accountId")],
        }
      },
    },
  }, {
    encodeValuesOnly: true, // prettify URL
  });

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/teams?${query}&populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getTeamById = async (id) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/teams/${id}?populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getTeamMembers = async (teamId) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/accounts?filters[teams]=${teamId}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getTeamMembersByIDs = async (idList) => {
  if(!idList ||idList.length === 0) return [];

  const query = qs.stringify(
    {
      filters: {
        id: {
          $in: idList,
        },
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/accounts?${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

